import { Hero } from '../components/sections/Hero';
import { FeaturedProducts } from '../components/sections/FeaturedProducts';
import { WhyChooseUs } from '../components/sections/WhyChooseUs';
import { Newsletter } from '../components/sections/Newsletter';
import { usePageSEO } from '../hooks/usePageSEO';

export function Home() {
  usePageSEO({
    title: 'WellZora Herbal Care | 100% Natural Herbal Medicine & Wellness Pakistan',
    description: "Shop Pakistan's trusted 100% natural herbal products. Laboratory tested, DRAP approved herbal formulations with fast free cash on delivery across Pakistan.",
    canonical: 'https://wellzoraherbalcare.com/',
    ogImage: 'https://wellzoraherbalcare.com/assets/Logo.jpg',
  });

  return (
    <>
      <Hero />
      <FeaturedProducts />
      <WhyChooseUs />
      <Newsletter />
    </>
  );
}